const snomedCT = {
    "102258003": "Gliadin",
    "102259006": "Citrus fruit",
    "102260001": "Peanut butter",
    "102261002": "Strawberry",
    "102262009": "Chocolate",
    "102263004": "Eggs (edible)",
    "102264005": "Cheese",
    "102270004": "Growth stimulant",
    "102271000": "Efrotomycin",
    "10249006": "Agar",
    "102697003": "Lactalbumin",
    "102698008": "Alpha-lactalbumin",
    "102699000": "Beta-lactalbumin",
    "102746004": "Homocitrulline",
    "102747008": "Homocysteine",
    "102748003": "Anserine",
    "102750006": "Phosphoserine",
    "102751005": "Sulfur-bearing amino acid",
    "10827009": "Milk protein",
    "108513001": "Ketorolac tromethamine",
    "108520008": "Bromfenac",
    "108521007": "Bromfenac sodium",
    "108570006": "Fosinopril sodium",
    "108743002": "Pegademase",
    "108950008": "Cysteine hydrochloride",
    "109010000": "Microfibrillar collagen hemostat",
    "109015005": "Absorbable gelatin film",
    "109017002": "Absorbable gelatin powder",
    "109106000": "Tiopronin",
    "109202005": "Benzylpenicilloyl polylysine",
    "109240008": "Carrageenan",
    "10944007": "Taurine",
    "112000000": "Essential amino acid",
    "112001001": "Aromatic amino acid",
    "11526002": "Aspartame",
    "115343006": "2-aminobutyrate",
    "115358003": "3-aminoisobutyrate",
    "116127001": "Magnesium amino acids chelate",
    "116274004": "Artificial sweetener",
    "116957009": "Bovine shock protein antibody",
    "117633004": "Bovine osteocalcin",
    "125706008": "Sodium benzoate",
    "126076005": "Fish liver oil",
    "126077001": "Burbot liver oil",
    "126078006": "Percomorph liver oil",
    "126079003": "Percoid liver oil",
    "126080000": "Shark liver oil",
    "126081001": "Halibut liver oil",
    "126082008": "Cod liver oil",
    "127384006": "Salmon calcitonin",
    "129559002": "Juice",
    "129560007": "Fruit juice",
    "129561006": "Vegetable juice",
    "13577000": "Nut",
    "13781002": "Alpha amino isobutyric acid",
    "14125007": "Serine",
    "14139007": "Arginine glutamate",
    "14263006": "Prepared fish",
    "14971004": "Isoleucine",
    "15331006": "Glycine",
    "16313001": "Tea",
    "19839007": "Sorbitol",
    "20741000122103": "Tiropramide",
    "2159007": "Azorubin S stain",
    "2254005": "Orotic acid",
    "22559002": "Glycoasparagine",
    "225748000": "Artificial feed",
    "226017009": "Bombay mix",
    "226018004": "Bourbon",
    "226019007": "Brandy",
    "226021002": "Cauliflower cheese",
    "226022009": "Cheese pastry",
    "226023004": "Cheesecake",
    "226024005": "Chocolate digestive biscuit",
    "226025006": "Cider",
    "226026007": "Cocoa drink",
    "226031009": "Gin",
    "226032002": "Malted milk drink",
    "226033007": "Hot chocolate drink",
    "226036004": "Lager",
    "226037008": "Lasagne",
    "226038003": "Liqueur",
    "226040008": "Martini",
    "226041007": "Mint",
    "226046002": "Plain digestive biscuit",
    "226047006": "Port",
    "226053006": "Rose wine",
    "226054000": "Rum",
    "226057007": "Sherry",
    "226061001": "Tamarind",
    "226062008": "Trail mix",
    "226064009": "Vodka",
    "226367006": "Eicosapentaenoic acid",
    "226368001": "Docosahexaenoic acid",
    "226465004": "Drinks",
    "226466003": "Milky drink",
    "226467007": "Milk shake drink",
    "226468002": "Milk shake powder drink",
    "226469005": "Milk shake syrup drink",
    "226470006": "Coffee with milk",
    "226471005": "Coffee with milk and sugar",
    "226472003": "Black coffee",
    "226473008": "Black coffee with sugar",
    "226474002": "Tea with milk",
    "226475001": "Tea with milk and sugar",
    "226476000": "Black tea",
    "226477009": "Black tea with sugar",
    "226478004": "Herbal tea",
    "226479007": "Carbonated drink",
    "226480005": "Sugar-free carbonated drink",
    "226481009": "Cola drink",
    "226482002": "Sugar-free cola",
    "226483007": "Lemon-flavored carbonated drink",
    "226484001": "Sugar-free lemonade",
    "226486004": "Tonic water",
    "226487008": "Sugar-free tonic water",
    "226488003": "Fruit squash drink",
    "226489006": "Diluted fruit squash drink",
    "226491003": "Apple juice",
    "226492005": "Grape juice",
    "226493000": "Grapefruit juice",
    "226495007": "Lemon juice",
    "226496008": "Orange juice",
    "226497004": "Pineapple juice",
    "226498009": "Tomato juice",
    "226499001": "Sports drink",
    "226500005": "Bitter beer",
    "226501009": "Pale ale",
    "226502002": "Low alcohol beer",
    "226503007": "Low carbohydrate beer",
    "226504001": "Home brewed beer",
    "226505000": "Strong ale",
    "226506004": "Brown ale",
    "226507008": "Stout",
    "226508003": "Low alcohol lager",
    "226509006": "Low carbohydrate lager",
    "226510001": "High alcohol lager",
    "226511002": "Home brewed lager",
    "226512009": "Dry cider",
    "226513004": "Sweet cider",
    "226514005": "Vintage cider",
    "226515006": "Strong cider",
    "226516007": "Dry white wine",
    "226517003": "Medium white wine",
    "226518008": "Sweet white wine",
    "226519000": "Sparkling white wine",
    "226520006": "Low alcohol wine",
    "226521005": "Home brewed wine",
    "226522003": "Dry sherry",
    "226523008": "Medium sherry",
    "226524002": "Sweet sherry",
    "226525001": "Dry martini",
    "226526000": "Sweet martini",
    "226527009": "Advocaat",
    "226528004": "Whisky",
    "226529007": "Starchy food",
    "226530002": "Baby cereal",
    "226531003": "Rusk",
    "226532005": "Flavored rusk",
    "226533000": "Low sugar rusk",
    "226534006": "Plain rusk",
    "226535007": "Wholemeal rusk",
    "226536008": "Rice-based baby cereal",
    "226537004": "Mixed cereal-based baby cereal",
    "226538009": "Wheat-based baby cereal",
    "226539001": "Cookie and/or cracker",
    "226540004": "Chocolate biscuit",
    "226541000": "Full coated chocolate biscuit",
    "226542007": "Half-coated chocolate biscuit",
    "226543002": "Cracker",
    "226544008": "Cream cracker",
    "226546005": "Wholemeal cracker",
    "226547001": "Crispbread",
    "226548006": "Digestive biscuit",
    "226549003": "Gingernut biscuit",
    "226550003": "Home-made biscuit",
    "226551004": "Matzo",
    "226552006": "Oatcake",
    "226553001": "Sandwich biscuit",
    "226554007": "Semi-sweet biscuit",
    "226555008": "Short-sweet biscuit",
    "226556009": "Shortbread biscuit",
    "226557000": "Wafer biscuit",
    "226558005": "Water biscuit",
    "226559002": "Bread",
    "226560007": "Brown bread",
    "226561006": "Brown bread roll",
    "226562004": "Breadcrumbs",
    "226563009": "Chapati",
    "226564003": "White chapati",
    "226565002": "White chapati made with fat",
    "226566001": "White chapati made without fat",
    "226567005": "Wholemeal chapati",
    "226568000": "Wholemeal chapati made with fat",
    "226569008": "Wholemeal chapati made without fat",
    "226570009": "Currant bread",
    "226571008": "Granary bread",
    "226572001": "Granary bread roll",
    "226574000": "Malt bread",
    "226575004": "Naan bread",
    "226576003": "Papadum",
    "226577007": "Fried papadum",
    "226578002": "Grilled papadum",
    "226579005": "Paratha",
    "226580008": "Pita bread",
    "226581007": "White pita bread",
    "226582000": "Wholemeal pita bread",
    "226583005": "Milk bread",
    "226584004": "Rye bread",
    "226585003": "Soda bread",
    "226587006": "Tortilla",
    "226589009": "Wheatgerm bread",
    "226590000": "White bread",
    "226592008": "Fried white bread",
    "226593003": "West Indian white bread",
    "226595005": "White bread roll",
    "226596006": "Wholemeal bread",
    "226597002": "Wholemeal bread roll",
    "226598007": "Breakfast cereal",
    "226601002": "Bran flakes",
    "226604005": "Cornflakes",
    "226611009": "Muesli",
    "226612002": "Muesli Swiss style",
    "226613007": "Muesli with extra fruit",
    "226614001": "Muesli with no added sugar",
    "226616004": "Oat and wheat bran",
    "226617008": "Porridge",
    "226618003": "Porridge made with milk",
    "226619006": "Porridge made with semi-skimmed milk",
    "226620000": "Porridge made with skimmed milk",
    "226621001": "Porridge made with whole milk",
    "226622008": "Porridge made with water",
    "226639005": "Cake",
    "226640007": "All bran loaf",
    "226641006": "Battenburg cake",
    "226642004": "Welsh cheesecake",
    "226643009": "Cherry cake",
    "226644003": "Chinese cake",
    "226645002": "Chinese glutinous rice flour cake",
    "226647005": "Chocolate cake",
    "226648000": "Chocolate cake with butter icing",
    "226649008": "Coconut cake",
    "226650008": "Crispie cake",
    "226651007": "Fancy iced cake",
    "226652000": "Fruit cake",
    "226653005": "Plain fruit cake",
    "226654004": "Rich fruit cake",
    "226655003": "Iced fruit cake",
    "226656002": "Wholemeal fruit cake",
    "226657006": "Gateau",
    "226658001": "Gingerbread",
    "226659009": "Lardy cake",
    "226660004": "Madeira cake",
    "226661000": "Rock cake",
    "226662007": "Sevyiann",
    "226663002": "Sponge cake",
    "226664008": "Fatless sponge cake",
    "226665009": "Frozen sponge cake",
    "226666005": "Jam-filled sponge cake",
    "226667001": "Fresh cream-filled sponge cake",
    "226668006": "Sponge cake with butter icing",
    "226669003": "Sponge cake made with cake mix",
    "226670002": "Swiss roll",
    "226671003": "Chocolate filled swiss roll",
    "226672005": "Jam filled swiss roll",
    "226673000": "Individual swiss roll",
    "226674006": "Welsh cake",
    "226675007": "Individual cakes and pastries",
    "226676008": "Asian pastry",
    "226677004": "Brandy snap",
    "226678009": "Burfi",
    "226679001": "Chelsea bun",
    "226680003": "Choux bun",
    "226681004": "Cream horn",
    "226682006": "Crumpet",
    "226683001": "Currant bun",
    "226684007": "Custard tart",
    "226685008": "Danish pastry",
    "226686009": "Doughnut",
    "226687000": "Jam doughnut",
    "226688005": "Ring doughnut",
    "226689002": "Fresh cream doughnut",
    "226690006": "Eccles cake",
    "226691005": "Eclair",
    "226692003": "Flapjack",
    "226693008": "Greek pastry",
    "226694002": "Gulab jamen",
    "226695001": "Halwa",
    "226697009": "Hot cross bun",
    "226699007": "Jam tart",
    "226700008": "Jellabi",
    "226701007": "Melting moment",
    "226702000": "Mince pie",
    "226703005": "Mincemeat tart",
    "226704004": "Muffin",
    "226705003": "Pinni",
    "226706002": "Rum baba",
    "226707006": "Scone",
    "226708001": "Cheese scone",
    "226709009": "Fruit scone",
    "226710004": "Plain scone",
    "226711000": "Potato scone",
    "226712007": "Wholemeal scone",
    "226713002": "Wholemeal fruit scone",
    "226714008": "Scotch pancake",
    "226715009": "Shortbread",
    "226716005": "Strawberry tartlet",
    "226717001": "Teacake",
    "226718006": "Vanilla slice",
    "226719003": "Waffle",
    "226720009": "Arrowroot",
    "226721008": "Pearl barley",
    "226722001": "Whole grain barley",
    "226723006": "Buckwheat - cereal",
    "226724000": "Bulgur wheat",
    "226725004": "Oatmeal",
    "226726003": "Popcorn",
    "226727007": "Plain popcorn",
    "226728002": "Sweet popcorn",
    "226729005": "Salted popcorn",
    "226730000": "Buttered popcorn",
    "226731001": "Sago",
    "226732008": "Semolina",
    "226733003": "Tapioca",
    "226734009": "Wheatgerm",
    "226735005": "Noodles",
    "226736006": "Egg noodles",
    "226737002": "Fried noodles",
    "226738007": "Plain noodles",
    "226739004": "Pot noodles",
    "226740002": "Pasta",
    "226741003": "Cannelloni",
    "226742005": "Macaroni",
    "226743000": "Ravioli",
    "226744006": "Spaghetti",
    "226745007": "White spaghetti",
    "226746008": "Wholemeal spaghetti",
    "226747004": "Tinned spaghetti",
    "226748009": "Vermicelli",
    "226749001": "Pastry",
    "226750001": "Choux pastry",
    "226751002": "Flaky pastry",
    "226752009": "Flan case pastry",
    "226753004": "Puff pastry",
    "226754005": "Shortcrust pastry",
    "226755006": "Wholemeal pastry",
    "226756007": "Brown rice",
    "226757003": "Red rice",
    "226758008": "Savory rice",
    "226759000": "White rice",
    "226760005": "Dairy food",
    "226761009": "Channel island milk",
    "226762002": "Flavored cow's milk",
    "226763007": "Semi-skimmed milk",
    "226764001": "Calcium fortified semi-skimmed milk",
    "226765000": "Calcium fortified skimmed milk",
    "226766004": "Sterilized milk",
    "226767008": "Whole milk",
    "226768003": "Calcium fortified whole milk",
    "226769006": "Buttermilk",
    "226770007": "Whey",
    "226771006": "Dried milk",
    "226774003": "Buttermilk powder",
    "226775002": "Dried goat's milk",
    "226776001": "Dried cow's milk",
    "226777005": "Dried semi-skimmed cow's milk",
    "226778000": "Dried skimmed cow's milk",
    "226779008": "Dried skimmed cow's milk with vegetable fat",
    "226780006": "Dried whole milk",
    "226781005": "Dried soya milk",
    "226782003": "Dried whey",
    "226783008": "Tinned milk",
    "226784002": "Condensed milk",
    "226785001": "Skimmed sweetened condensed milk",
    "226786000": "Whole sweetened condensed milk",
    "226787009": "Evaporated milk",
    "226788004": "Low fat evaporated milk",
    "226789007": "Breast milk",
    "226790003": "Expressed breast milk",
    "226791004": "Sheep milk",
    "226793001": "Soya milk",
    "226795008": "Follow on milk",
    "226796009": "Fresh cream",
    "226797000": "Half-cream",
    "226798005": "Double cream",
    "226799002": "Clotted cream",
    "226800003": "Single cream",
    "226801004": "Soured cream",
    "226802006": "Whipping cream",
    "226803001": "Tinned cream",
    "226805008": "Imitation cream",
    "226808005": "Smatana",
    "226809002": "Cheese spread",
    "226810007": "Plain cheese spread",
    "226811006": "Flavored cheese spread",
    "226812004": "Lactic cheese spread",
    "226813009": "Low fat cheese spread",
    "226814003": "Cottage cheese",
    "226815002": "Plain cottage cheese",
    "226816001": "Very low fat cottage cheese",
    "226817005": "Cottage cheese with additions",
    "226818000": "Hard cheese",
    "226819008": "Caerphilly cheese",
    "226820002": "Cheddar cheese",
    "226821003": "Reduced fat cheddar cheese",
    "226822005": "Vegetarian cheddar cheese",
    "226823000": "Cheshire cheese",
    "226824006": "Reduced fat Cheshire cheese",
    "226825007": "Derby cheese",
    "226826008": "Danish blue cheese",
    "226827004": "Double Gloucester cheese",
    "226828009": "Edam cheese",
    "226829001": "Edam-type cheese reduced fat",
    "226830006": "Emmental cheese",
    "226831005": "Feta cheese",
    "226832003": "Gouda cheese",
    "226834002": "Gruyere cheese",
    "226835001": "Lancashire cheese",
    "226836000": "Leicester cheese",
    "226837009": "Mozzarella cheese",
    "226838004": "Parmesan cheese",
    "226839007": "Red Windsor cheese",
    "226840009": "Roquefort cheese",
    "226841008": "Sage Derby cheese",
    "226842001": "Soya cheese",
    "226843006": "Stilton - white cheese",
    "226844000": "Stilton - blue cheese",
    "226845004": "Wensleydale cheese",
    "226846003": "Processed cheese",
    "226847007": "Smoked processed cheese",
    "226848002": "Soft cheese",
    "226849005": "Cream cheese",
    "226850005": "Medium fat cream cheese",
    "226851009": "Low fat cream cheese",
    "226852002": "Goats milk soft cheese",
    "226853007": "Ricotta cheese",
    "226854001": "Soft mold ripened cheese",
    "226855000": "Brie cheese",
    "226856004": "Camembert cheese",
    "226857008": "Fromage frais",
    "226858003": "Plain fromage frais",
    "226859006": "Flavored fromage frais",
    "226860001": "Fruit fromage frais",
    "226861002": "Very low fat fromage frais",
    "226862009": "Quark",
    "226863004": "Yogurt",
    "226864005": "Whole milk yogurt",
    "226865006": "Whole milk plain yogurt",
    "226866007": "Whole milk fruit yogurt",
    "226867003": "Whole milk flavored yogurt",
    "226868008": "Live yogurt",
    "226869000": "Organic yogurt",
    "226870004": "Goat's milk yogurt",
    "226871000": "Low fat yogurt",
    "226872007": "Plain low fat yogurt",
    "226873002": "Flavored low fat yoghurt",
    "226874008": "Fruit low fat yogurt",
    "226875009": "Muesli-nut low fat yogurt",
    "226876005": "Low calorie yogurt",
    "226877001": "Drinking yogurt",
    "226878006": "Greek yogurt",
    "226879003": "Sheep's milk yogurt",
    "226880000": "Soya milk yogurt",
    "226881001": "Dried egg",
    "226882008": "Boiled egg",
    "226883003": "Fried egg",
    "226884009": "Poached egg",
    "226885005": "Raw egg",
    "226886006": "Scrambled egg",
    "226887002": "Fat and oil",
    "226888007": "Butter",
    "226889004": "Blended spread",
    "226890008": "Margarine",
    "226891007": "Hard vegetable fat margarine",
    "226892000": "Hard animal and vegetable fat margarine",
    "226894004": "Soft polyunsaturated fat margarine",
    "226895003": "Monounsaturated fat margarine",
    "226896002": "Low fat spread",
    "226897006": "Very low fat spread",
    "226898001": "Dripping",
    "226899009": "Lard",
    "226900004": "Suet",
    "226901000": "Ghee",
    "226902007": "Butter ghee",
    "226903002": "Palm oil ghee",
    "226904008": "Vegetable oil ghee",
    "226907001": "Palm oil",
    "226908006": "Rapeseed oil",
    "226909003": "Rapeseed oil high erucic acid",
    "226910008": "Rapeseed oil low erucic acid",
    "226911007": "Soya oil",
    "226912000": "Sunflowerseed oil",
    "226913005": "Blended vegetable oil",
    "226914004": "Polyunsaturated vegetable oil",
    "226915003": "Red meat",
    "226916002": "Beef",
    "226917006": "Beef steak",
    "226918001": "Grilled beef steak",
    "226919009": "Fried beef steak",
    "226920003": "Boiled beef",
    "226921004": "Boiled salt beef",
    "226922006": "Minced beef",
    "226923001": "Stewed minced beef",
    "226924007": "Stewed extra-lean minced beef",
    "226925008": "Roast beef",
    "226926009": "Lean roast beef",
    "226927000": "Stewed steak",
    "226928005": "Bacon",
    "226929002": "Boiled bacon",
    "226930007": "Fried bacon",
    "226931006": "Grilled bacon",
    "226932004": "Gammon",
    "226933009": "Roast gammon",
    "226934003": "Pork",
    "226935002": "Fried pork chop",
    "226936001": "Grilled pork chop",
    "226937005": "Minced pork",
    "226938000": "Roast pork",
    "226939008": "Lean roast pork",
    "226940005": "Roast belly pork",
    "226941009": "Boiled ham",
    "226942002": "Lamb",
    "226943007": "Fried lamb chop",
    "226944001": "Grilled lamb chop",
    "226945000": "Minced lamb",
    "226946004": "Roast lamb",
    "226947008": "Lean roast lamb",
    "226948003": "Roast leg of lamb",
    "226949006": "Roast shoulder of lamb",
    "226950006": "Roast breast of lamb",
    "226951005": "Stewed lamb",
    "226952003": "Veal",
    "226953008": "Fried veal",
    "226954002": "Grilled veal",
    "226955001": "Chicken - meat",
    "226956000": "Boiled chicken",
    "226957009": "Fried chicken",
    "226958004": "Fried chicken in batter",
    "226959007": "Fried chicken in breadcrumb",
    "226960002": "Fried chicken nuggets",
    "226961003": "Roast chicken",
    "226962005": "Minced chicken",
    "226963000": "Duck - meat",
    "226964006": "Roast duck",
    "226965007": "Goose",
    "226966008": "Roast goose",
    "226967004": "Turkey - meat",
    "226968009": "Roast turkey",
    "226969001": "Stewed turkey",
    "226970000": "Minced turkey",
    "226971001": "Game - meat",
    "226972008": "Grouse - meat",
    "226973003": "Roast grouse",
    "226974009": "Partridge - meat",
    "226975005": "Roast partridge",
    "226976006": "Pheasant - meat",
    "226977002": "Roast pheasant",
    "226978007": "Roast pigeon",
    "226979004": "Roast venison",
    "226980001": "Stewed hare",
    "226981002": "Stewed rabbit",
    "226982009": "Offal",
    "226983004": "Heart - meat",
    "226984005": "Stewed heart",
    "226985006": "Roast heart",
    "226987003": "Kidney - meat",
    "226988008": "Fried kidney",
    "226989000": "Grilled kidney",
    "226990009": "Stewed kidney",
    "226991008": "Liver - meat",
    "226992001": "Fried liver",
    "226993006": "Grilled liver",
    "226994000": "Stewed liver",
    "226995004": "Oxtail",
    "226996003": "Stewed oxtail",
    "226997007": "Sweetbread",
    "226998002": "Fried sweetbread",
    "226999005": "Tongue - meat",
    "227000008": "Tripe",
    "227001007": "Dressed tripe",
    "227002000": "Dressed stewed tripe",
    "227003005": "Meat products",
    "227004004": "Burger",
    "227005003": "Beef burger",
    "227006002": "Pork burger",
    "227007006": "Lamb burger",
    "227008001": "Chicken burger",
    "227009009": "Turkey burger",
    "227010004": "Black pudding",
    "227011000": "Brawn",
    "227012007": "Faggot",
    "227013002": "Haggis",
    "227014008": "Liver pate",
    "227015009": "Low fat liver pate",
    "227016005": "Meat paste",
    "227017001": "Polony",
    "227018006": "Salami",
    "227019003": "Saveloy",
    "227020009": "Sausage",
    "227021008": "Frankfurter",
    "227022001": "Low fat sausage",
    "227023006": "Beef sausage",
    "227024000": "Low fat beef sausage",
    "227025004": "Pork sausage",
    "227026003": "Low fat pork sausage",
    "227027007": "Turkey sausage",
    "227028002": "Low fat turkey sausage",
    "227029005": "Liver sausage",
    "227030000": "White pudding",
    "227031001": "Processed meat",
    "227032008": "Chicken roll",
    "227033003": "Chopped ham and pork",
    "227034009": "Corned beef",
    "227036006": "Luncheon meat",
    "227038007": "White fish",
    "227040002": "Bele",
    "227041003": "Boal",
    "227042005": "Bream",
    "227044006": "Chinese salted fish",
    "227045007": "Chital",
    "227046008": "Baked cod",
    "227047004": "Poached cod",
    "227048009": "Grilled cod",
    "227049001": "Fried cod",
    "227050001": "Fried cod in batter",
    "227051002": "Fried cod in breadcrumbs",
    "227052009": "Fried cod goujons in breadcrumbs",
    "227053004": "Cod in batter baked in the oven",
    "227054005": "Dried salted cod",
    "227055006": "Smoked poached cod",
    "227058008": "Dab",
    "227060005": "Poached haddock",
    "227061009": "Fried haddock",
    "227062002": "Fried haddock in batter",
    "227063007": "Fried haddock in breadcrumbs",
    "227064001": "Fried haddock goujons in breadcrumbs",
    "227065000": "Smoked poached haddock",
    "227066004": "Hake",
    "227067008": "Halibut",
    "227068003": "Hoki",
    "227069006": "Fried hoki in batter",
    "227070007": "John dory",
    "227071006": "Kalabasu",
    "227072004": "Lemon sole",
    "227073009": "Poached lemon sole",
    "227074003": "Fried lemon sole",
    "227075002": "Fried lemon sole in breadcrumbs",
    "227076001": "Ling",
    "227078000": "Monkfish",
    "227080006": "Grey mullet",
    "227081005": "Red mullet",
    "227083008": "Plaice",
    "227084002": "Poached plaice",
    "227085001": "Fried plaice",
    "227086000": "Fried plaice in batter",
    "227087009": "Fried plaice in breadcrumbs",
    "227088004": "Fried plaice goujons in breadcrumbs",
    "227089007": "Pollack",
    "227092006": "Black pomfret",
    "227093001": "White pomfret",
    "227096009": "Rohu",
    "227097000": "Rock salmon",
    "227098005": "Fried rock salmon in batter",
    "227099002": "Saithe",
    "227101009": "Shark - food",
    "227103007": "Fried skate in batter",
    "227104001": "Tiliapa",
    "227105000": "Turbot",
    "227106004": "Whiting",
    "227107008": "Poached whiting",
    "227108003": "Fried whiting",
    "227109006": "Fried whiting in breadcrumbs",
    "227110001": "Fatty fish",
    "227111002": "Bacha",
    "227114005": "Jellied eel",
    "227115006": "Dried herring",
    "227116007": "Fried herring in oatmeal",
    "227117003": "Grilled herring",
    "227118008": "Pickled herring",
    "227119000": "Hilsa",
    "227120006": "Jackfish",
    "227121005": "Katla",
    "227122003": "Kipper",
    "227123008": "Poached kipper",
    "227124002": "Grilled kipper",
    "227126000": "Fried mackerel",
    "227127009": "Grilled mackerel",
    "227128004": "Smoked mackerel",
    "227129007": "Grilled smoked mackerel",
    "227130002": "Orange roughy",
    "227131003": "Pangas",
    "227132005": "Grilled salmon",
    "227133000": "Poached salmon",
    "227134006": "Smoked salmon",
    "227135007": "Salmon en croute",
    "227136008": "Sardine",
    "227137004": "Grilled sardine",
    "227138009": "Fried sardine",
    "227139001": "Sprats",
    "227141000": "Fried trout",
    "227142007": "Baked trout",
    "227143002": "Smoked trout",
    "227144008": "Tuna fish",
    "227145009": "Whitebait fried",
    "227147001": "Cockles",
    "227148006": "Cockles bottled in vinegar",
    "227150003": "Mussel",
    "227151004": "Prawns",
    "227152006": "Boiled prawns",
    "227153001": "Fried prawns",
    "227154007": "Fried prawns in batter",
    "227155008": "Dried prawns",
    "227156009": "Scampi",
    "227157000": "Fried scampi in batter",
    "227158005": "Fried scampi in breadcrumbs",
    "227159002": "Fried shrimp",
    "227160007": "Dried shrimp",
    "227164003": "Dried squid",
    "227165002": "Fried squid",
    "227167005": "Fried squid in batter",
    "227168000": "Whelks",
    "227169008": "Winkles",
    "227170009": "Fish products",
    "227171008": "Crabstick",
    "227172001": "Fish ball",
    "227173006": "Fishcake",
    "227174000": "Grilled fishcake",
    "227175004": "Fried fishcake",
    "227176003": "Fish fingers",
    "227177007": "Fried fish fingers",
    "227178002": "Grilled fish fingers",
    "227179005": "Fish paste",
    "227180008": "Fish pate",
    "227181007": "Fish pie",
    "227182000": "Kedgeree",
    "227183005": "Fish roe",
    "227184004": "Raw hard fish roe",
    "227185003": "Fried hard fish roe",
    "227186002": "Fried hard fish roe in batter",
    "227187006": "Raw soft fish roe",
    "227188001": "Fried soft fish roe",
    "227189009": "Seafood cocktail",
    "227190000": "Taramasalata",
    "227191001": "Tinned fish",
    "227193003": "Anchovies canned in oil",
    "227194009": "Herring canned in tomato sauce",
    "227195005": "Mackerel canned in tomato sauce",
    "227196006": "Mackerel canned in brine",
    "227197002": "Mussels canned in brine",
    "227198007": "Pilchards canned in tomato sauce",
    "227199004": "Pilchards canned in brine",
    "227200001": "Salmon canned in brine",
    "227201002": "Sardines canned in brine",
    "227202009": "Sardines canned in oil",
    "227203004": "Sardines canned in tomato sauce",
    "227204005": "Tuna canned in brine",
    "227205006": "Tuna canned in oil",
    "227206007": "Crab canned in brine",
    "227207003": "Shrimps canned in brine",
    "227208008": "Abalone canned in brine",
    "227209000": "Clams canned in brine",
    "227210005": "Vegetables pulses herbs and spices",
    "227212002": "Alfalfa sprout",
    "227213007": "Amaranth leaf",
    "227214001": "Arrowhead",
    "227215000": "Artichoke",
    "227216004": "Globe artichoke",
    "227217008": "Jerusalem artichoke",
    "227218003": "Asparagus",
    "227219006": "Aubergine",
    "227220000": "Beetroot",
    "227221001": "Brassica vegetable",
    "227225005": "Chinese cabbage",
    "227226006": "Red cabbage",
    "227227002": "Savoy cabbage",
    "227228007": "Spring cabbage",
    "227229004": "White cabbage",
    "227230009": "Curly kale",
    "227231008": "Kohl rabi",
    "227232001": "Seakale",
    "227233006": "Breadfruit",
    "227234000": "Cassava",
    "227235004": "Celeriac",
    "227236003": "Chard",
    "227238002": "Cho cho",
    "227239005": "Zucchini",
    "227240007": "Cole leaf",
    "227242004": "Drumstick leaf",
    "227244003": "Fenugreek",
    "227245002": "Gherkin",
    "227247005": "Jackfruit",
    "227249008": "Lotus tuber",
    "227250008": "Marrow",
    "227251007": "Matoki",
    "227253005": "Mustard leaf",
    "227254004": "Okra",
    "227255003": "Spring onion",
    "227258001": "Patra leaf",
    "227259009": "Plantain",
    "227260004": "Pumpkin",
    "227261000": "Raddiccio",
    "227262007": "Radish white - mooli",
    "227263002": "Rape leaf",
    "227264008": "Salsify",
    "227265009": "Seaweed",
    "227266005": "Swede",
    "227268006": "Sweetcorn",
    "227269003": "Sweetcorn kernels",
    "227270002": "Sweetcorn on-the-cob",
    "227271003": "Tannia",
    "227272005": "Taro",
    "227273000": "Taro leaves",
    "227274006": "Tomato puree",
    "227275007": "Turnip",
    "227276008": "Water chestnut",
    "227277004": "Watercress",
    "227279001": "Boiled potato",
    "227280003": "Potato boiled in salted water",
    "227281004": "Potato boiled in unsalted water",
    "227282006": "French fries",
    "227283001": "Thick cut French fries",
    "227284007": "Thin cut French fries",
    "227285008": "Crinkle cut chips",
    "227286009": "French fries cooked in corn oil",
    "227287000": "French fries cooked in fat drippings",
    "227288005": "French fries cooked in blended oil",
    "227289002": "French fries cooked in polyunsaturated oil",
    "227290006": "Microwave French fries",
    "227291005": "Oven French fries",
    "227292003": "Jacket potato",
    "227294002": "Mashed potato",
    "227295001": "Potato mashed with butter",
    "227296000": "Potato mashed with margarine",
    "227297009": "Potato mashed with milk",
    "227298004": "Potato mashed with polyunsaturated margarine",
    "227299007": "Roast potato",
    "227300004": "Potato roasted in vegetable oil",
    "227301000": "Potato roasted in polyunsaturated oil",
    "227302007": "Potato roasted in dripping",
    "227303002": "Tinned potato",
    "227304008": "Potato tinned in salted water",
    "227305009": "Potato tinned in unsalted water",
    "227306005": "Instant potato",
    "227307001": "Instant potato made up with water",
    "227308006": "Instant potato made up with semi-skimmed milk",
    "227309003": "Instant potato made up with skimmed milk",
    "227310008": "Instant potato made up with whole milk",
    "227311007": "Potato croquette fried in blended oil",
    "227312000": "Potato waffle",
    "227313005": "Pulse vegetable",
    "227314004": "Canned beans",
    "227315003": "Baked beans",
    "227316002": "Baked beans canned in tomato sauce",
    "227317006": "Baked beans canned in tomato sauce reduced sugar",
    "227318001": "Baked beans canned in tomato sauce reduced salt",
    "227319009": "Baked beans canned in tomato sauce with burgers",
    "227320003": "Baked beans canned in tomato sauce with pork sausages",
    "227321004": "Balor beans canned",
    "227322006": "Barbecue beans canned in sauce",
    "227323001": "Canned mung beansprouts",
    "227324007": "Canned broad beans",
    "227325008": "Canned butter beans",
    "227326009": "Canned chick peas",
    "227327000": "Canned chili beans",
    "227328005": "Canned haricot beans",
    "227329002": "Canned lilva beans",
    "227330007": "Canned lentils in tomato sauce",
    "227331006": "Canned papri beans",
    "227332004": "Canned peas",
    "227333009": "Canned garden peas",
    "227334003": "Canned marrowfat peas",
    "227335002": "Canned mushy peas",
    "227336001": "Canned pease pudding",
    "227337005": "Canned red kidney beans",
    "227338000": "Aduki beans",
    "227339008": "Beansprouts",
    "227340005": "Raw mung beansprouts",
    "227341009": "Stir-fried mung beansprouts",
    "227342002": "Black gram beans",
    "227343007": "Blackeye beans",
    "227345000": "Butter beans",
    "227346004": "Chick peas",
    "227347008": "Cluster beans",
    "227348003": "Haricot beans",
    "227349006": "Hummus",
    "227350006": "Lentils",
    "227351005": "Green lentils",
    "227352003": "Brown lentils",
    "227353008": "Red split lentils",
    "227354002": "Miso",
    "227355001": "Mung beans",
    "227356000": "Mung bean dahl",
    "227357009": "Papri beans",
    "227358004": "Pigeon peas",
    "227359007": "Pigeon pea dahl",
    "227360002": "Pinto beans",
    "227361003": "Refried pinto beans",
    "227362005": "Red kidney beans",
    "227363000": "Sword beans",
    "227364006": "Tempeh",
    "227365007": "Tofu",
    "227366008": "Steamed tofu",
    "227367004": "Steamed fried tofu",
    "227368009": "Fu-juk tofu",
    "227369001": "Fresh peas",
    "227370000": "Fresh raw peas",
    "227371001": "Fresh boiled peas",
    "227372008": "Dried boiled peas",
    "227373003": "Dried boiled split peas",
    "227374009": "Herbs and spices",
    "227375005": "Allspice",
    "227376006": "Anise seed",
    "227377002": "Asafetida",
    "227379004": "Bay leaf",
    "227380001": "Betel leaf",
    "227381002": "Caraway seed",
    "227382009": "Cardamom",
    "227383004": "Celery seed",
    "227384005": "Chervil, dried",
    "227385006": "Chili powder",
    "227386007": "Chinese five spice",
    "227387003": "Chive - herb",
    "227388008": "Cinnamon",
    "227389000": "Clove",
    "227390009": "Coriander leaf",
    "227391008": "Coriander seed",
    "227392001": "Cumin seed",
    "227393006": "Curry leaf",
    "227395004": "Curry powder",
    "227396003": "Fennel",
    "227397007": "Fennel seed",
    "227398002": "Fenugreek seed",
    "227399005": "Garam masala",
    "227400003": "Ginger",
    "227401004": "Ground ginger",
    "227402006": "Root ginger",
    "227403001": "Liquorice powder",
    "227404007": "Mace",
    "227405008": "Marjoram",
    "227406009": "Mustard seed",
    "227407000": "Oregano",
    "227408005": "Paprika",
    "227409002": "Poppy seed",
    "227410007": "Rosemary",
    "227411006": "Sage",
    "227412004": "Tarragon",
    "227413009": "Thyme",
    "227414003": "Turmeric",
    "227415002": "Fruit nuts and seeds",
    "227416001": "Fresh fruit",
    "227417005": "Bilberries",
    "227418000": "Blackberries",
    "227419008": "Blackcurrants",
    "227420002": "Clementine",
    "227421003": "Cranberries",
    "227422005": "Damson",
    "227423000": "Dates - food",
    "227424006": "Elderberries",
    "227425007": "Figs",
    "227426008": "Fresh fruit salad",
    "227427004": "Gooseberries",
    "227428009": "Greengage",
    "227429001": "Guava",
    "227430006": "Lime - fruit",
    "227431005": "Kumquat",
    "227432003": "Loganberries",
    "227433008": "Lychee",
    "227434002": "Mulberries",
    "227435001": "Nectarine",
    "227436000": "Olives",
    "227437009": "Ortanique",
    "227438004": "Passion fruit",
    "227439007": "Paw-paw",
    "227441008": "Pomegranate",
    "227442001": "Pomelo",
    "227443006": "Quince",
    "227444000": "Raspberries",
    "227445004": "Redcurrants",
    "227446003": "Satsuma",
    "227447007": "Sharon fruit",
    "227448002": "White currant",
    "227449005": "Dried fruit",
    "227450005": "Dried banana",
    "227451009": "Dried apple",
    "227452002": "Dried apricot",
    "227453007": "Currants",
    "227454001": "Dried date",
    "227455000": "Dried fig",
    "227456004": "Dried mixed fruit",
    "227457008": "Dried mixed peel",
    "227458003": "Dried peach",
    "227459006": "Dried pear",
    "227460001": "Dried pineapple",
    "227461002": "Glace cherry",
    "227462009": "Prunes",
    "227463004": "Raisins",
    "227464005": "Sultanas",
    "227465006": "Tinned fruit",
    "227466007": "Tinned apple",
    "227467003": "Tinned apricot",
    "227468008": "Tinned blackcurrants",
    "227469000": "Tinned cherries",
    "227470004": "Tinned figs",
    "227471000": "Tinned fruit cocktail",
    "227472007": "Tinned gooseberries",
    "227473002": "Tinned grapefruit",
    "227474008": "Tinned guava",
    "227475009": "Tinned kumquat",
    "227476005": "Tinned loganberries",
    "227477001": "Tinned lychees",
    "227478006": "Tinned mandarin oranges",
    "227479003": "Tinned mango",
    "227480000": "Tinned paw-paw",
    "227481001": "Tinned peaches",
    "227482008": "Tinned pears",
    "227483003": "Tinned pineapple",
    "227484009": "Tinned plums",
    "227485005": "Tinned prunes",
    "227486006": "Tinned raspberries",
    "227487002": "Tinned rhubarb",
    "227488007": "Tinned strawberries",
    "227489004": "Tinned fruit pie filling",
    "227490008": "Barcelona nut",
    "227491007": "Betel nut",
    "227492000": "Breadnut seed",
    "227493005": "Cashew nut",
    "227495003": "Roasted and salted cashew nuts",
    "227496002": "Fresh coconut",
    "227497006": "Creamed coconut",
    "227498001": "Desiccated coconut",
    "227499009": "Coconut cream",
    "227500000": "Coconut milk",
    "227501001": "Macadamia nut",
    "227502008": "Marzipan home-made",
    "227503003": "Marzipan retail",
    "227504009": "Melon seed",
    "227505005": "Mixed nuts",
    "227506006": "Mixed nuts and raisins",
    "227507002": "Smooth peanut butter",
    "227508007": "Crunchy peanut butter",
    "227509004": "Dry roasted peanuts",
    "227510009": "Salted peanuts",
    "227511008": "Pine nut",
    "227512001": "Pistachio nut",
    "227513006": "Roasted salted pistachio nut",
    "227514000": "Pumpkin seed",
    "227515004": "Quinoa",
    "227516003": "Tahini paste",
    "227517007": "Tigernut",
    "227518002": "Sauces seasonings and soups",
    "227519005": "Sauce",
    "227520004": "Dairy sauce",
    "227521000": "Bread sauce",
    "227522007": "Cheese sauce",
    "227523002": "Cheese sauce packet mix",
    "227524008": "Onion sauce",
    "227525009": "Savory white sauce",
    "227526005": "Sweet white sauce",
    "227527001": "Barbecue sauce",
    "227528006": "Brown sauce",
    "227529003": "Cook-in-sauce",
    "227530008": "Packet cook-in sauce",
    "227531007": "Canned cook-in sauce",
    "227532000": "Curry sauce",
    "227533005": "Horseradish sauce",
    "227534004": "Mint sauce",
    "227535003": "Pasta sauce",
    "227536002": "Tomato sauce",
    "227537006": "Soy sauce",
    "227538001": "Pickle",
    "227539009": "Branston pickle",
    "227540006": "Lime pickle",
    "227541005": "Chutney",
    "227542003": "Apple chutney",
    "227543008": "Mango chutney",
    "227544002": "Tomato chutney",
    "227545001": "Salad dressing",
    "227546000": "French dressing",
    "227547009": "Low calorie french dressing",
    "227548004": "Polyunsaturated oil french dressing",
    "227549007": "Mayonnaise",
    "227550007": "Low calorie mayonnaise",
    "227551006": "Creamy salad dressing",
    "227552004": "Low calorie creamy salad dressing",
    "227553009": "Seasoning",
    "227554003": "Baking powder",
    "227556001": "Gravy mix",
    "227557005": "Gravy granules",
    "227559008": "Smooth mustard",
    "227560003": "Wholegrain mustard",
    "227563001": "Pepper - seasoning",
    "227564007": "Salt - food",
    "227565008": "Vinegar",
    "227566009": "Soup",
    "227567000": "Home-made soup",
    "227568005": "Home-made lentil soup",
    "227569002": "Home-made thick vegetable soup",
    "227570001": "Home-made thin vegetable soup",
    "227571002": "Home-made cream soup",
    "227572009": "Tinned soup",
    "227573004": "Tinned cream of chicken soup",
    "227574005": "Tinned cream of mushroom soup",
    "227575006": "Tinned cream of tomato soup",
    "227576007": "Tinned low calorie soup",
    "227577003": "Tinned oxtail soup",
    "227578008": "Tinned vegetable soup",
    "227579000": "Packet soup",
    "227580002": "Chicken noodle packet soup",
    "227581003": "Instant packet soup",
    "227582005": "Low calorie instant packet soup",
    "227583000": "Minestrone packet soup",
    "227584006": "Oxtail packet soup",
    "227585007": "Tomato packet soup",
    "227586008": "Savory snacks",
    "227587004": "Corn snacks",
    "227589001": "Potato chips",
    "227590005": "Low fat potato chips",
    "227591009": "Potato hoops",
    "227592002": "Tortilla chips",
    "227594001": "Sugary food",
    "227595000": "Jam and preserves",
    "227597008": "Chocolate nut spread",
    "227598003": "Honey",
    "227599006": "Honeycomb",
    "227600009": "Jaggery",
    "227601008": "Jam",
    "227602001": "Reduced sugar jam",
    "227603006": "Lemon curd",
    "227604000": "Marmalade",
    "227605004": "Mincemeat",
    "227606003": "Molasses",
    "227607007": "Candy",
    "227608002": "Chocolate candy",
    "227610000": "Milk chocolate",
    "227611001": "Plain chocolate",
    "227612008": "White chocolate",
    "227613003": "Cooking chocolate",
    "227620005": "Sugar candy",
    "227621009": "Hard candy",
    "227622002": "Fruit gum",
    "227623007": "Licorice candy",
    "227624001": "Cough drop",
    "227625000": "Peppermint-containing candy",
    "227626004": "Toffee",
    "227627008": "Turkish delight",
    "227628003": "Cheese and egg dishes",
    "227629006": "Cheese and potato pie",
    "227630001": "Cheese pudding",
    "227631002": "Macaroni cheese",
    "227632009": "Quiche",
    "227633004": "Cheese and egg quiche",
    "227634005": "Mushroom quiche",
    "227635006": "Raita plain",
    "227636007": "Raita yogurt and gram flour",
    "227637003": "Tzatziki",
    "227638008": "Welsh rarebit",
    "227639000": "Omelette",
    "227640003": "Plain omelette",
    "227641004": "Cheese omelette",
    "227642006": "Spanish omelette",
    "227643001": "Curried omelette",
    "227644007": "Egg fu yung",
    "227645008": "Egg fried rice",
    "227646009": "Scotch egg",
    "227648005": "Souffle plain",
    "227649002": "Souffle cheese",
    "227650002": "Meat dishes",
    "227651003": "Barbecued spare rib",
    "227652005": "Beef chow mein",
    "227653000": "Beef steak pudding",
    "227654006": "Beef stew",
    "227655007": "Bolognese sauce",
    "227656008": "Chicken chow-mein",
    "227657004": "Chicken pie",
    "227658009": "Chili con carne",
    "227659001": "Chinese meat bun",
    "227660006": "Cornish pastie",
    "227661005": "Cottage pie",
    "227662003": "Hot pot",
    "227663008": "Irish stew",
    "227664002": "Meat pakora",
    "227665001": "Meat pie",
    "227666000": "Meat samosa",
    "227667009": "Meat curry",
    "227668004": "Beef kheema",
    "227669007": "Beef kofta",
    "227670008": "Chicken curry",
    "227671007": "Lamb kheema",
    "227672000": "Mutton biriani",
    "227673005": "Mutton curry",
    "227674004": "Moussaka",
    "227675003": "Pancake roll",
    "227676002": "Pork pie",
    "227677006": "Sausage roll",
    "227678001": "Shepherd's pie",
    "227679009": "Spaghetti bolognaise",
    "227680007": "Steak and kidney pie",
    "227681006": "Sweet and sour pork",
    "227682004": "Dessert",
    "227683009": "Bakewell tart",
    "227684003": "Blancmange",
    "227685002": "Bread and butter pudding",
    "227686001": "Bread pudding",
    "227687005": "Christmas pudding",
    "227688000": "Creme caramel",
    "227689008": "Custard",
    "227690004": "Custard made with whole milk",
    "227691000": "Custard made with semi-skimmed milk",
    "227692007": "Custard made with skimmed milk",
    "227693002": "Tinned custard",
    "227694008": "Confectioners' custard",
    "227696005": "Egg custard",
    "227698006": "Eve's pudding",
    "227699003": "Flan case sponge",
    "227700002": "Fruit crumble",
    "227701003": "Fruit fool",
    "227702005": "Fruit pie",
    "227703000": "Fruit pie one crust",
    "227704006": "Fruit pie pastry top and bottom",
    "227705007": "Fruit pie individual",
    "227706008": "Fruit pie wholemeal one crust",
    "227707004": "Fruit pie wholemeal pastry top and bottom",
    "227708009": "Ice cream",
    "227709001": "Reduced calorie ice cream",
    "227710006": "Arctic roll",
    "227711005": "Banana split",
    "227712003": "Choc ice",
    "227713008": "Chocolate nut sundae",
    "227715001": "Knickerbocker glory",
    "227716000": "Kulfi",
    "227717009": "Peach melba",
    "227718004": "Instant dessert powder",
    "227719007": "Instant desert powder made with semi-skimmed milk",
    "227720001": "Instant desert powder made with skimmed milk",
    "227721002": "Instant desert powder made with whole milk",
    "227722009": "Jello",
    "227723004": "Jello made with water",
    "227724005": "Jello made with whole milk",
    "227725006": "Jello made with semi-skimmed milk",
    "227726007": "Jello made with skimmed milk",
    "227727003": "Lemon meringue pie",
    "227728008": "Meringue with cream",
    "227729000": "Milk pudding",
    "227730005": "Milk pudding made with whole milk",
    "227731009": "Milk pudding made with semi-skimmed milk",
    "227732002": "Milk pudding made with skimmed milk",
    "227733007": "Tinned milk pudding",
    "227734001": "Mousse",
    "227735000": "Chocolate mousse",
    "227736004": "Fruit mousse",
    "227737008": "Frozen mousse",
    "227738003": "Queen of puddings",
    "227739006": "Sherbet",
    "227740008": "Sponge pudding",
    "227741007": "Sponge pudding with dried fruit",
    "227742000": "Sponge pudding with jam or treacle",
    "227743005": "Spotted dick",
    "227744004": "Suet pudding",
    "227745003": "Sweet pancake",
    "227746002": "Treacle tart",
    "227747006": "Trifle",
    "227748001": "Frozen trifle",
    "227750009": "Trifle with fresh cream",
    "227751008": "Savory dishes",
    "227752001": "Chevra and chana chur",
    "227753006": "Chinese flaky pastry",
    "227754000": "Couscous",
    "227755004": "Dumpling",
    "227756003": "Masur",
    "227757007": "Pizza",
    "227758002": "Ravioli canned in tomato sauce",
    "227759005": "Risotto",
    "227760000": "Spaghetti canned in bolognese sauce",
    "227761001": "Spaghetti canned in tomato sauce",
    "227762008": "Stuffing mix",
    "227763003": "Stuffing sage and onion",
    "227764009": "Yorkshire pudding",
    "227765005": "Vegetable dishes",
    "227766006": "Aubergine dishes",
    "227767002": "Aubergine stuffed with lentils and vegetables",
    "227768007": "Aubergine stuffed with rice",
    "227769004": "Aubergine stuffed with vegetables and cheese",
    "227770003": "Bean loaf",
    "227771004": "Bhaji",
    "227772006": "Aubergine and potato bhaji",
    "227773001": "Aubergine pea potato and cauliflower bhaji",
    "227774007": "Cabbage bhaji",
    "227775008": "Cabbage and pea bhaji",
    "227776009": "Cabbage and potato bhaji",
    "227777000": "Cabbage and spinach bhaji",
    "227778005": "Carrot potato and pea bhaji",
    "227779002": "Cauliflower bhaji",
    "227780004": "Cauliflower and potato bhaji",
    "227781000": "Cauliflower potato and pea bhaji",
    "227782007": "Cauliflower and vegetable bhaji",
    "227783002": "Green bean bhaji",
    "227784008": "Karela bhaji",
    "227785009": "Mushroom bhaji",
    "227786005": "Mustard leaves bhaji",
    "227787001": "Mustard leaves and spinach bhaji",
    "227788006": "Onion bhaji",
    "227789003": "Okra bhaji",
    "227790007": "Pea bhaji",
    "227791006": "Potato bhaji",
    "227792004": "Potato and fenugreek leaves bhaji",
    "227793009": "Potato and green pepper bhaji",
    "227794003": "Potato and onion bhaji",
    "227795002": "Potato onion and mushroom bhaji",
    "227796001": "Potato spinach and cauliflower bhaji",
    "227797005": "Spinach bhaji",
    "227799008": "Spinach and potato bhaji",
    "227800007": "Turnip bhaji",
    "227801006": "Turnip and onion bhaji",
    "227802004": "Vegetable bhaji",
    "227803009": "Vegetables in sauce",
    "227804003": "Broccoli in cheese sauce",
    "227805002": "Cauliflower in white sauce",
    "227806001": "Bubble and squeak",
    "227807005": "Bubble and squeak fried in lard",
    "227808000": "Bubble and squeak fried in polyunsaturated oil",
    "227809008": "Bubble and squeak fried in vegetable oil",
    "227810003": "Callaloo and cho cho",
    "227811004": "Cho cho fritter fried in vegetable oil",
    "227812006": "Callaloo and okra",
    "227813001": "Vegetable casserole",
    "227814007": "Vegetable casserole made with beans and mixed vegetables",
    "227815008": "Vegetable casserole made with beans and root vegetables",
    "227816009": "Vegetable casserole made with sweet potato and green banana",
    "227817000": "Cauliflower with onion and chili pepper",
    "227818005": "Vegetable chili",
    "227819002": "Bean and lentil chili",
    "227821007": "Coco fritter fried in vegetable oil",
    "227822000": "Coo-coo",
    "227823005": "Corn fritter",
    "227824004": "Corn pudding",
    "227825003": "Zucchini with egg",
    "227826002": "Vegetable curry",
    "227827006": "Almond curry",
    "227828001": "Aubergine curry",
    "227829009": "Black gram dahl curry",
    "227830004": "Bengali black gram curry",
    "227831000": "Gujerati black gram curry",
    "227832007": "Black gram and red kidney bean curry",
    "227833002": "Gujerati black-eye bean curry",
    "227834008": "Punjabi black-eye bean curry",
    "227835009": "Bombay potato curry",
    "227836005": "Cabbage curry",
    "227837001": "Cauliflower and potato curry",
    "227838006": "Chick pea curry",
    "227839003": "Chick pea dahl curry",
    "227841002": "Chick pea dahl and spinach curry",
    "227842009": "Chick pea and potato curry",
    "227843004": "Chick pea and tomato curry",
    "227844005": "Zucchini and potato curry",
    "227845006": "Dudhi kofta curry",
    "227846007": "Green bean curry",
    "227847003": "Karela curry",
    "227848008": "Mixed vegetable curry",
    "227849000": "Lentil curry",
    "227850000": "Split lentil curry",
    "227851001": "Mung bean curry",
    "227852008": "Mung bean dahl curry",
    "227853003": "Mung bean dahl and spinach curry",
    "227854009": "Mung bean dahl and tomato curry",
    "227855005": "Mung bean and turnip leaves curry",
    "227856006": "Okra curry",
    "227857002": "Pea and potato curry",
    "227858007": "Pigeon pea dahl curry",
    "227859004": "Pigeon pea dahl and tomato curry",
    "227860009": "Pigeon pea dahl with tomato and peanuts curry",
    "227861008": "Potato curry",
    "227862001": "Red kidney bean curry",
    "227863006": "Red kidney and mung bean curry",
    "227864000": "Spinach curry",
    "227865004": "Spinach and potato curry",
    "227866003": "Tinda and potato curry",
    "227867007": "Dal dhokari",
    "227868002": "Dosa",
    "227869005": "Falafel",
    "227870006": "Fu-fu - sweet potato",
    "227871005": "Garlic mushrooms",
    "227872003": "Guacamole",
    "227873008": "Khadhi",
    "227874002": "Khatiyu",
    "227875001": "Khichadi",
    "227876000": "Laverbread",
    "227877009": "Lentil dishes",
    "227878004": "Lentil cutlet",
    "227879007": "Lentil pie",
    "227880005": "Lentil and cheese pie",
    "227881009": "Lentil and potato pie",
    "227882002": "Lentil roast",
    "227883007": "Lentil roast with egg",
    "227884001": "Lentil and nut roast",
    "227885000": "Lentil and nut roast with egg",
    "227886004": "Lentil and rice roast",
    "227887008": "Lentil and rice roast with egg",
    "227888003": "Mchicha",
    "227889006": "Mushroom dopiaza",
    "227890002": "Nut dishes",
    "227891003": "Nut croquette fried in polyunsaturated oil",
    "227892005": "Nut croquette fried in vegetable oil",
    "227893000": "Nut cutlet",
    "227894006": "Nut roast",
    "227895007": "Nut roast with egg",
    "227896008": "Nut and rice roast",
    "227897004": "Nut and rice roast with egg",
    "227898009": "Nut and seed roast",
    "227899001": "Nut and seed roast with egg",
    "227901005": "Nut and vegetable roast",
    "227902003": "Nut and vegetable roast with egg",
    "227903008": "Nut mushroom and rice roast",
    "227904002": "Okra with tomato and onion",
    "227905001": "Pepper stuffed with rice",
    "227906000": "Pepper stuffed with vegetables and cheese",
    "227907009": "Pilaf",
    "227908004": "Pilau",
    "227909007": "Pilau rice",
    "227910002": "Potato dishes",
    "227911003": "Potato cakes",
    "227912005": "Potato leek and celery bake",
    "227914006": "Ratatouille",
    "227915007": "Red cabbage cooked with apple",
    "227916008": "Red pea loaf",
    "227917004": "Rice dishes",
    "227918009": "Rice and beans",
    "227919001": "Rice and split peas",
    "227920007": "Vegetable risotto",
    "227921006": "Rissole",
    "227922004": "Bean rissole",
    "227923009": "Lentil rissole",
    "227924003": "Rice rissole",
    "227925002": "Vegetable rissole",
    "227926001": "Roulade spinach",
    "227927005": "Salad",
    "227928000": "Bean salad",
    "227929008": "Beetroot salad",
    "227930003": "Carrot and nut salad with french dressing",
    "227931004": "Carrot and nut salad with mayonnaise",
    "227932006": "Coleslaw",
    "227933001": "Coleslaw with mayonnaise",
    "227934007": "Coleslaw with reduced calorie dressing",
    "227935008": "Coleslaw with vinaigrette",
    "227936009": "Florida salad",
    "227937000": "Greek salad",
    "227938005": "Green salad",
    "227939002": "Pasta salad",
    "227940000": "Potato salad",
    "227941001": "Potato salad with french dressing",
    "227942008": "Potato salad with mayonnaise",
    "227943003": "Potato salad with reduced calorie mayonnaise",
    "227944009": "Rice salad",
    "227945005": "Tomato and onion salad",
    "227946006": "Tinned vegetable salad",
    "227947002": "Waldorf salad",
    "227948007": "Soya mince granules",
    "227949004": "Sweet potato and onion layer",
    "227950004": "Tabouleh",
    "227951000": "Tofu spread",
    "227952007": "Tomato stuffed with rice",
    "227953002": "Tomato stuffed with vegetables",
    "227954008": "Vegebanger",
    "227955009": "Vegebanger fried in polyunsaturated oil",
    "227956005": "Vegebanger fried in vegetable oil",
    "227957001": "Grilled vegebanger",
    "227958006": "Vegeburger",
    "227959003": "Vegeburger fried in polyunsaturated oil",
    "227960008": "Vegeburger fried in vegetable oil",
    "227961007": "Grilled vegeburger",
    "227962000": "Beanburger",
    "227963005": "Grilled beanburger",
    "227964004": "Fried beanburger",
    "227965003": "Tempeh burger",
    "227966002": "Tofu burger",
    "227967006": "Vegetable bake",
    "227968001": "Vegetable crumble",
    "227969009": "Vegetable flan",
    "227970005": "Vegetable lasagne",
    "227971009": "Vegetable moussaka",
    "227972002": "Vegetable pakora",
    "227973007": "Vegetable pancake",
    "227974001": "Vegetable pancake roll",
    "227975000": "Vegetable pasty",
    "227976004": "Vegetable pate",
    "227977008": "Vegetable pie",
    "227978003": "Vegetable samosa",
    "227979006": "Vegetable stir fry",
    "227980009": "Vegetable tagliatelle",
    "227981008": "Vine leaves stuffed with rice",
    "227982001": "Appetizing food",
    "227983006": "Baby food",
    "227984000": "Commercial baby food",
    "227985004": "Dried baby food",
    "227986003": "Canned baby food",
    "227987007": "Baby food in jars",
    "227988002": "Home prepared baby food",
    "227989005": "Canned food",
    "227990001": "Chinese food",
    "227991002": "Carbohydrate food",
    "227992009": "High carbohydrate food",
    "227993004": "Low carbohydrate food",
    "227994005": "Complex carbohydrate food",
    "227995006": "Refined carbohydrate food",
    "227996007": "Simple carbohydrate food",
    "227997003": "Calcium fortified food",
    "227998008": "Convenience food",
    "227999000": "Cooked food",
    "228000006": "Cook chill food",
    "228002003": "Fried food",
    "228003008": "Grilled food",
    "228004002": "Lightly cooked food",
    "228005001": "Microwaved food",
    "228006000": "Over-cooked food",
    "228007009": "Well cooked food",
    "228008004": "Dried food",
    "228009007": "Dry food",
    "228010002": "Familiar food",
    "228011003": "Family food",
    "228012005": "Fatty food",
    "228013000": "High monounsaturated fat food",
    "228014006": "High polyunsaturated fat food",
    "228015007": "High saturated fat food",
    "228016008": "Finger food",
    "228017004": "Folate fortified food",
    "228018009": "Food temperature",
    "228019001": "Cold food",
    "228020007": "Hot food",
    "228021006": "Warm food",
    "228022004": "Fresh food",
    "228023009": "Frozen food",
    "228025002": "Health food",
    "228026001": "High calcium food",
    "228027005": "High energy food",
    "228028000": "High fiber food",
    "228029008": "High soluble fiber food",
    "228030003": "High insoluble fiber food",
    "228031004": "High glycemic index food",
    "228032006": "High phytate food",
    "228033001": "High risk food",
    "228034007": "Contaminated food",
    "228035008": "Iron fortified food",
    "228036009": "Iron-rich food",
    "228037000": "Heme iron-rich food",
    "228038005": "Low energy food",
    "228039002": "Low fat food",
    "228040000": "Low polyunsaturated fat food",
    "228041001": "Low saturated fat food",
    "228042008": "Low fiber food",
    "228043003": "Low glycemic index food",
    "228044009": "Low risk food",
    "228045005": "Sterile food",
    "228046006": "Low salt food",
    "228047002": "Low sugar food",
    "228048007": "Chewy food",
    "228049004": "Chopped food",
    "228051000": "Clear fluid",
    "228052007": "Crunchy food",
    "228053002": "Cut-up food",
    "228055009": "Liquidized food",
    "228056005": "Lumpy food",
    "228057001": "Semi-solid food",
    "228058006": "Single texture food",
    "228059003": "Soft food",
    "228060008": "Solid food",
    "228061007": "Thickened fluid",
    "228062000": "Nutritious food",
    "228063005": "Organic food",
    "228064004": "Protein food",
    "228065003": "High protein food",
    "228066002": "Low protein food",
    "228067006": "Raw food",
    "228068001": "Rich food",
    "228069009": "Salty food",
    "228070005": "Snack food",
    "228071009": "Spicy food",
    "228072002": "Sweet food",
    "228073007": "Vegetarian food",
    "228074001": "Vegan food",
    "228075000": "Weaning food",
    "228076004": "Wheat-free food",
    "228077008": "Whole food",
    "228078003": "Yellow 2G",
    "228079006": "Ponceau 4R",
    "228082001": "Patent blue V",
    "228083006": "Brilliant blue FCF",
    "228085004": "Caramel",
    "228086003": "Black PN",
    "228087007": "Brown FK",
    "228088002": "Brown HT",
    "228089005": "Potassium benzoate",
    "228090001": "Calcium benzoate",
    "228092009": "Ethyl 4-hydroxybenzoate sodium salt",
    "228094005": "Propyl 4-hydroxybenzoate sodium salt",
    "228097003": "Methyl 4-hydroxybenzoate sodium salt",
    "228099000": "Calcium sulfite",
    "228100008": "Calcium hydrogen sulfite",
    "228102000": "Sodium nitrate",
    "228103005": "Food antioxidant",
    "228104004": "Butylated hydroxyanisole",
    "228105003": "Monopotassium glutamate",
    "228106002": "Calcium glutamate",
    "228107006": "Guanosine 5'-disodium phosphate",
    "228108001": "Inosine 5'-disodium phosphate",
    "228109009": "Sodium 5'-ribonucleotide",
    "228110004": "Food sweetener",
    "228111000": "Acesulfame potassium",
    "228113002": "Thaumatin",
    "22836000": "Vegetable",
    "228980007": "Strong beer",
    "228981006": "Strong lager",
    "228982004": "Fortified wine",
    "228983009": "Home produced spirit",
    "22968009": "Sunset yellow FCF stain",
    "229775001": "Apple flavor",
    "229776000": "Orange flavor",
    "229777009": "Pineapple flavor",
    "229778004": "Blackcurrant flavor",
    "229779007": "Lemon flavor",
    "229780005": "Lime flavor",
    "229781009": "Mixed fruit flavor",
    "229848001": "Blended spread - 70-80% fat",
    "229849009": "Blended spread - 40% fat",
    "229850009": "Butteroil",
    "229851008": "Spreadable butter",
    "229852001": "Beef dripping",
    "229853006": "Pork dripping",
    "229854000": "Compound cooking fat",
    "229855004": "Polyunsat compound cooking fat",
    "229857007": "Shredded suet",
    "229858002": "Vegetable suet",
    "229859005": "Dairy spread",
    "229860000": "Diabetic jam",
    "229861001": "Chocolate spread",
    "229862008": "Syrup",
    "229863003": "Dark corn syrup",
    "229864009": "Golden syrup",
    "229865005": "Maple syrup",
    "229866006": "Fruit spread",
    "229867002": "Diabetic marmalade",
    "229868007": "Home-made lemon curd",
    "229869004": "Vegetarian mincemeat",
    "229870003": "Blackstrap molasses",
    "229871004": "Icing",
    "229872006": "Butter icing",
    "229873001": "Fondant icing",
    "229874007": "Glace icing",
    "229875008": "Royal icing",
    "229876009": "Diabetic chocolate",
    "229877000": "Chocolate covered caramel",
    "229878005": "Chocolate with filled center",
    "229879002": "Chocolate covered fruit/nut bar",
    "229880004": "Chocolate covered wafer/biscuit bar",
    "229883002": "Chocolate truffle",
    "229884008": "Chewy candy",
    "229885009": "Fudge",
    "229887001": "Marshmallow",
    "229888006": "Nougat",
    "229889003": "Peanut brittle",
    "229890007": "Peppermint cream",
    "229891006": "Fizzy candy",
    "229892004": "Turkish delight with nuts",
    "229893009": "Halva",
    "229894003": "Carrot halva",
    "229895002": "Semolina halva",
    "229896001": "Chevda",
    "229897005": "Corn and starch snacks",
    "229898000": "Maize and rice flour snacks",
    "229899008": "Mixed cereal and potato snacks",
    "229900003": "Oriental mix",
    "229901004": "Pork scratchings",
    "229902006": "Crinkle cut potato chips",
    "229903001": "Square potato chips",
    "229904007": "Thick cut potato chips",
    "229905008": "Potato and corn sticks",
    "229906009": "Potato and tapioca snacks",
    "229907000": "Pot savories",
    "229908005": "Pretzels",
    "229909002": "Punjabi puri",
    "229910007": "Sev",
    "229919008": "Irish whisky",
    "229920002": "Scotch whisky",
    "229922005": "Meat sandwich",
    "229923000": "Cheese sandwich",
    "229924006": "Egg sandwich",
    "229925007": "Salad sandwich",
    "229926008": "Jam sandwich",
    "229928009": "Wheatgerm oil",
    "229929001": "Walnut oil",
    "229930006": "Hazelnut oil",
    "229932003": "Grapeseed oil",
    "229933008": "Chapati flour",
    "229934002": "Chick pea flour",
    "229936000": "Corn starch",
    "229937009": "Custard powder",
    "229938004": "Gari",
    "229939007": "Hominy",
    "229940009": "Rye flour",
    "229941008": "Soya flour",
    "229942001": "Millet flour",
    "229943006": "Potato flour",
    "229944000": "Wheat flour",
    "229945004": "Milky coffee",
    "229946003": "Brown chapati flour",
    "229947007": "White chapati flour",
    "229948002": "Cornmeal",
    "229949005": "Low fat soya flour",
    "229950005": "Brown flour",
    "229951009": "White flour",
    "229952002": "White plain flour",
    "229953007": "White self-raising flour",
    "229954001": "Wholemeal flour",
    "229955000": "Dried egg white",
    "229956004": "General food types",
    "229957008": "Food composition types",
    "229959006": "Food temperature types",
    "229960001": "Food hygiene types",
    "229961002": "Food consistency types",
    "229962009": "Baby food types",
    "229963004": "Cultural food types",
    "229965006": "Food state types",
    "229966007": "Boiled food",
    "229967003": "Steamed food",
    "229968008": "Asian food",
    "229969000": "Indian food",
    "229970004": "Vietnamese food",
    "229971000": "West African food",
    "229972007": "West Indian food",
    "229973002": "Folate-rich foods",
    "229974008": "High potassium food",
    "229975009": "Low potassium food",
    "229976005": "Food additive-free foods",
    "229977001": "Food coloring-free food",
    "229978006": "Food preservative-free food",
    "229979003": "General food and drink types",
    "229980000": "Drink types",
    "229981001": "Clean food",
    "229982008": "Pickled food",
    "230033008": "Prickly pear - fruit",
    "230034002": "Nuts and seeds",
    "230037009": "Mint - herb",
    "230044000": "Hot drink",
    "230045004": "Soft margarine not polyunsaturated",
    "230046003": "Non-polyunsaturated low fat spread 40% fat",
    "230047007": "Non-polyunsaturated low fat spread 70-80% fat",
    "230048002": "Polyunsaturated low fat spread 70% fat",
    "230049005": "Polyunsaturated low fat spread 60% fat",
    "230050005": "Polyunsaturated low fat spread 35-40% fat",
    "230051009": "Beverage whiteners",
    "230052002": "Savory food",
    "230053007": "White sugar",
    "230054001": "Icing sugar",
    "230055000": "Brown sugar",
    "23182003": "Cereal",
    "23969007": "Tryparsamide",
    "24515005": "Spice",
    "255620007": "Food",
    "255621006": "Cream",
    "255685004": "Bovine fibrinogen",
    "255859001": "Butylated hydroxytoluene",
    "255864002": "Ethyl 4-hydroxybenzoate",
    "255868004": "Methyl 4-hydroxybenzoate",
    "255871007": "Propyl 4-hydroxybenzoate",
    "255971006": "Quinoline yellow",
    "256249000": "Tamarind seed",
    "256306003": "Orange - fruit",
    "256307007": "Banana",
    "256313003": "Pineapple",
    "256315005": "Grapefruit",
    "256316006": "Tangerine",
    "256317002": "Grapes",
    "256318007": "Green bean",
    "256319004": "Carrot",
    "256320005": "Cress",
    "256322002": "Potato with peel",
    "256325000": "Radish",
    "256326004": "Celery",
    "256329006": "Spinach",
    "256330001": "Herb",
    "256331002": "Dill",
    "256350002": "Almond",
    "256351003": "Brazil nut",
    "256352005": "Walnut - nut",
    "256353000": "Hazelnut",
    "256354006": "Bean",
    "256355007": "Soya bean",
    "256442007": "Egg yolk",
    "256443002": "Egg white",
    "256444008": "Bovine vein",
    "25743006": "Skim milk",
    "25761002": "Glutamine",
    "259098002": "Aminoisobutyric acid",
    "259100002": "Gamma-aminobutyric acid",
    "259547003": "Free L-carnitine",
    "260167008": "Sesame seed",
    "260168003": "White bean",
    "260176001": "Kiwi fruit",
    "260177005": "Melon",
    "260179008": "Mango fruit",
    "260180006": "Red pepper",
    "260184002": "Pea",
    "260188004": "Chestnut",
    "260189007": "Pecan nut",
    "260201000": "Castor bean",
    "260204008": "Cotton seed",
    "260205009": "Sunflower seed",
    "261242008": "Bovine internal mammary artery",
    "264294006": "Cotoneaster berries",
    "264295007": "Cow's milk protein",
    "264322002": "Sugar - food",
    "264330001": "Firethorn berries",
    "264331002": "Grain",
    "264332009": "Holly berries",
    "264334005": "Mahonia berries",
    "264335006": "Rowan berries",
    "264337003": "Seed",
    "26645004": "Homocystine",
    "27138006": "Saccharin",
    "27378009": "Tyrosine",
    "276338007": "Dummy blueberries",
    "278393006": "Animal milk protein",
    "278840001": "Shrimp",
    "280941009": "Cold drink",
    "280990009": "Muscovado sugar",
    "28230009": "Poultry",
    "284068003": "Pigeon - meat",
    "28421003": "Sorbic acid",
    "284458003": "Casein-based baby milk",
    "284459006": "Low birth weight baby milk",
    "284460001": "Soya-based baby milk",
    "284461002": "Whey-based baby milk",
    "284462009": "Lean grilled bacon",
    "284463004": "Lean grilled lamb chop",
    "28647000": "Meat",
    "286550009": "Hen's egg",
    "288456005": "Caffeinated coffee",
    "288458006": "Caffeinated soft drinks",
    "28942008": "Coconut oil",
    "289966000": "Bovine artery",
    "29263009": "Coffee",
    "30022007": "Citrulline",
    "303300008": "Egg protein",
    "303301007": "Ovalbumin",
    "307059008": "Coal tar dyes",
    "310283001": "Vigabatrin",
    "31121009": "Gamma aminoisobutyric acid",
    "311455009": "Absinthe",
    "312184007": "L-methionine",
    "314113006": "Low fat biscuit",
    "314115004": "Raw vegetable",
    "3161008": "3-methyl histidine",
    "34744002": "Plant asparagine",
    "35609001": "Azophloxin stain",
    "35748005": "Wine",
    "36434002": "1-methyl histidine",
    "3692009": "Sodium sulfite",
    "3718001": "Cow's milk",
    "372501008": "Ketorolac",
    "372510000": "Fosinopril",
    "372538008": "Irinotecan",
    "373489001": "Para-aminobenzoic acid",
    "373531009": "Gelatin",
    "37575004": "Carmoisine A stain",
    "37927000": "Cystine",
    "386127005": "Formula milk",
    "386845007": "Gabapentin",
    "386912006": "Irinotecan hydrochloride",
    "386945006": "Amino acid derivative",
    "387235007": "Penicillamine",
    "387440002": "Acetylcysteine",
    "387495008": "Metyrosine",
    "387501005": "Mesalamine",
    "38909000": "Glutamic acid hydrochloride",
    "39102003": "Food particle",
    "391698009": "Acamprosate",
    "391699001": "Acamprosate calcium",
    "391737006": "Almond oil",
    "391858005": "Bran",
    "395734009": "Guar gum",
    "395836000": "Polygeline",
    "395842001": "Carbocysteine",
    "395910008": "Tolfenamic acid",
    "39694009": "Kynurenic acid",
    "39862002": "Imino acid",
    "401620006": "Comminuted chicken meat suspension",
    "406758004": "Bovine derived substance",
    "406773003": "Fish derivative",
    "406774009": "Fish derived omega 3 fatty acid",
    "409425005": "Polylysine",
    "410982000": "Dicarboxylic amino acid",
    "410983005": "Diaminopimelic acid",
    "411973001": "Bovine thrombin",
    "412028008": "Bovine collagen",
    "412055004": "Apple pectin",
    "412056003": "Lima beans",
    "412060000": "Black pepper",
    "412061001": "Blueberries",
    "412062008": "Cantaloupe",
    "412064009": "Corn syrup",
    "412065005": "Squash",
    "412066006": "Pepper",
    "412067002": "Root beer",
    "412068007": "Rye",
    "412071004": "Wheat",
    "412089003": "Porcine antihemophilic factor agent",
    "412113006": "Cayenne",
    "412139009": "Bovine serum albumin",
    "412194001": "Green tea",
    "412201008": "Porcine heparin",
    "412202001": "Bovine heparin sodium",
    "412209005": "Porcine isophane insulin",
    "412295009": "Carglumic acid",
    "412357001": "Corn",
    "412533000": "Wheat bran",
    "412552006": "Vegetable oil",
    "412601002": "Carob",
    "412632001": "Alloisoleucine",
    "413480003": "Almond product",
    "414074006": "Egg product",
    "414290003": "Fortified milk",
    "414291004": "Fortified Vitamin D milk",
    "414542006": "Irradiated Vitamin D milk",
    "41459008": "Sodium bisulfite",
    "414625009": "Lycopene",
    "414983003": "Ovomucin",
    "415041004": "Pasteurized Dairy food",
    "415138005": "Porcine derived substance",
    "415160008": "Pregabalin",
    "415562007": "Soy bean product",
    "415768008": "Ultra pasteurized cream",
    "415769000": "Ultra pasteurized dairy food",
    "415842005": "Wheat product",
    "416198000": "Beef derivative",
    "417889008": "Arachis oil",
    "41810000": "Beta aminoisobutyric acid",
    "418280003": "Stevioside",
    "41834005": "Olive oil",
    "418504009": "Oat",
    "418614009": "Porcine factor VIII",
    "418929008": "Lactitol",
    "418992009": "Sucralose",
    "419420009": "Watermelon",
    "420053004": "Starflower oil",
    "420075002": "Monosodium L-aspartate",
    "420318001": "Bovine isophane insulin",
    "420823005": "Applesauce",
    "421562003": "Porcine regular insulin",
    "421619005": "Bovine regular insulin",
    "421884008": "Bovine insulin protamine zinc",
    "422721009": "Juglandaceae family nut",
    "422932000": "Anacardiaceae family nut",
    "423252004": "Home-canned food",
    "423703004": "Fermented food",
    "424967004": "Lumiracoxib",
    "425898006": "Rebaudioside",
    "426390004": "Droxidopa",
    "426701005": "Wheat grain fibrous extract",
    "427330005": "Hydroxyamino acid",
    "429592005": "Polydextrose",
    "430745006": "Carbamic acid",
    "436801000124100": "Unsaturated fat",
    "436811000124102": "Monounsaturated fat",
    "436821000124105": "Polyunsaturated fat",
    "436831000124108": "Trans fat",
    "436841000124103": "Saturated fat",
    "43708003": "Animal feed additive",
    "437941000124105": "Low monounsaturated fat food",
    "437951000124107": "Low trans fat food",
    "437961000124109": "High trans fat food",
    "437971000124102": "Low soluble fiber food",
    "437981000124104": "Low insoluble fiber food",
    "437991000124101": "Low cholesterol food",
    "43835003": "Zinc gelatin",
    "439091000124107": "Easy to chew food",
    "439181000124105": "Medical food",
    "439191000124108": "Medical beverage",
    "43984007": "Alpha amino acid",
    "44027008": "Seafood",
    "440551000124102": "Bioactive substance",
    "440561000124100": "Beta glucan",
    "440571000124107": "Non-nutritive food additive",
    "440581000124105": "Plant stanol ester",
    "440591000124108": "Plant sterol ester",
    "441647003": "Lacosamide",
    "441721000124109": "Fluid consistency type",
    "441751000124100": "Mashed food",
    "441761000124103": "Minced food",
    "441771000124105": "Moist food",
    "441791000124106": "Strained food",
    "441816007": "Ademetionine",
    "441821000124102": "Nectar-thick fluid",
    "441831000124104": "Pudding-thick liquid",
    "441841000124109": "Thin fluid",
    "441851000124106": "Thick fluid",
    "441881000124103": "Ground food",
    "442253006": "Saccharin sodium",
    "442421000124108": "Chinquapin nut",
    "442431000124106": "Beechnut",
    "442441000124101": "Shea nut",
    "442461000124102": "Hickory nut",
    "442471000124109": "Ginkgo nut",
    "442571000124108": "Tree nut",
    "443148002": "Omega-5 gliadin",
    "446273004": "Red food coloring",
    "446274005": "Yellow food coloring",
    "44970006": "Aspartic acid",
    "45475000": "Indigo carmine stain",
    "45997006": "Omega amino acid",
    "46329000": "Chocolate milk",
    "46491005": "Menthyl anthranilate",
    "4700006": "Beef insulin",
    "47617006": "Basic amino acid",
    "47703008": "Lactose",
    "4963003": "Neutral amino acid",
    "50479000": "Soy protein-iron complex",
    "50593009": "Casein",
    "50825000": "Food coloring",
    "51386004": "Food preservative",
    "51905005": "Mustard",
    "51963001": "Sulfite salt",
    "52518006": "Amino acid",
    "52541003": "Proline",
    "52560005": "Norleucine",
    "52625008": "Arginine",
    "52736009": "Threonine",
    "53410008": "Beer",
    "53527002": "Alcoholic beverage",
    "53875002": "Colostrum",
    "54041009": "Safflower oil",
    "54821000": "Tryptophan",
    "56740002": "Triiodotyrosine",
    "5691000": "Absorbable gelatin sponge",
    "58732000": "Red wine",
    "58753009": "Alanine",
    "5932006": "Cysteine",
    "59533004": "Food additive",
    "59882007": "Aminocaproic acid",
    "59888006": "Carnitine",
    "60260004": "Histidine",
    "6083003": "Hydroxylysine",
    "608772009": "Cocktail",
    "608773004": "Vermouth",
    "6249003": "Potassium metabisulfite",
    "63004003": "Phenylalanine",
    "63045006": "Berry",
    "63330006": "Nonessential amino acid",
    "63676001": "Arginine hydrochloride",
    "63766005": "Flour",
    "6524003": "Distilled spirits",
    "669361000168106": "Wheat dextrin",
    "67296003": "Pork insulin",
    "67324005": "Rice",
    "67990004": "White wine",
    "70113000": "Branched-chain amino acid",
    "70288006": "Racemethionine",
    "703122000": "Gabapentin enacarbil",
    "703340007": "Zofenopril",
    "703341006": "Zofenopril calcium",
    "703342004": "Zofenoprilat",
    "703343009": "Zofenoprilat arginine",
    "70587000": "Beta alanine",
    "706927001": "Free tryptophan",
    "706940006": "Free hydroxyproline",
    "706941005": "Free hydroxylysine",
    "706942003": "Free homocystine",
    "706943008": "Free homocysteine",
    "706946000": "Free gamma-aminobutyric acid",
    "706948004": "Free cystine",
    "706982005": "Xanthurenate",
    "707163005": "2-methylbutyrylglycine",
    "707230005": "Butyrylglycine",
    "707599007": "Gamma aminoadipate",
    "707615006": "Isobutyrylglycine",
    "707616007": "Kynurenine",
    "707661006": "Methionine sulfoxide",
    "707677007": "N-methyl valine",
    "707678002": "N-octanoylglycine",
    "707968002": "Valerylglycine",
    "707976000": "Trans-cinnamoylglycine",
    "708052008": "Glycoamino acid",
    "708053003": "Succinyladenosine",
    "70813002": "Milk",
    "708658008": "Zinc amino acid chelate",
    "708850004": "N-2-hydroxyethyl valine",
    "709060000": "Anthranilate",
    "709071004": "Succinylaminoimidazole carboxamide riboside",
    "709125009": "3-hydroxyanthranilate",
    "709131007": "Guanidinoacetic acid",
    "709152004": "Free carnitine",
    "709592008": "Cysteic acid",
    "709844000": "N-carbamoyl-beta-alanine",
    "710035004": "Star fruit",
    "710036003": "Beetroot seed",
    "710037007": "Beta-lactoglobulin",
    "710038002": "Bovine lactoferrin",
    "710039005": "Rape seed",
    "710040007": "Chili pepper",
    "710041006": "Gorgonzola cheese",
    "710042004": "Conalbumin",
    "710048000": "Japanese millet",
    "710051007": "Selenomethionine",
    "710171001": "Horse - meat",
    "710172008": "Hop",
    "710173003": "Blue vetch",
    "710174009": "Quinolinic acid",
    "710175005": "Megrim",
    "710176006": "Lovage",
    "710178007": "Linseed",
    "710179004": "Lupine seed",
    "710180001": "Malt",
    "710181002": "Mare's milk protein",
    "710182009": "Blue mussel",
    "710183004": "Rabbit - meat",
    "710184005": "Mutton",
    "710185006": "Spiny lobster",
    "710220009": "Common millet",
    "710224000": "Bamboo shoot",
    "710226003": "Rose hip",
    "710238007": "Delta alanine",
    "710276001": "Unripe peppercorn seed",
    "710949005": "Calcium amino acid chelate",
    "711335002": "Carbocysteine lysine",
    "711611001": "Pudding",
    "712565006": "Lysine acetate",
    "712594004": "Histadinyl-isoleucine",
    "712599009": "Betiatide",
    "712673008": "Porcine brain-derived peptide",
    "712685000": "Lactalbumin hydrolysate",
    "712800005": "Glycyl-tyrosine",
    "713310002": "Soy isoflavone",
    "713311003": "Soybean oil refined",
    "713336009": "Olive oil refined",
    "713357001": "Methiosulfonium chloride",
    "713372002": "Gelatin hydrolysate",
    "713480005": "Oxaceprol",
    "713648000": "Canola oil",
    "713664008": "Acylglycine",
    "715213000": "Irinotecan liposome",
    "716119001": "Eluxadoline",
    "717779009": "Butternut tree nut",
    "717782004": "Lichee nut",
    "718852000": "Safinamide",
    "719108000": "Lupin flour",
    "720489009": "Lifitegrast",
    "720490000": "Lifitegrast sodium",
    "72322001": "Para-aminobenzoic acid esters in alcohol",
    "724234003": "Allo-cystathionine",
    "724239008": "Alpha-aminoadipic semialdehyde",
    "72511004": "Fruit",
    "725193008": "Saccharopine",
    "725553002": "3-hydroxykynurenine",
    "725582001": "L-homoarginine",
    "725622009": "Nicotinurate",
    "725629000": "S-beta aminoisobutyrate",
    "725634001": "Trimethyllysine",
    "725636004": "3-ureidopropionate",
    "725729006": "Pimelate",
    "725788000": "Bromfenac sodium sesquihydrate",
    "725861003": "Irinotecan hydrochloride trihydrate",
    "725893006": "L-abrine",
    "725963001": "Glycyl-tyrosine dihydrate",
    "726730005": "Yam",
    "726731009": "Swordfish",
    "726749009": "Sea bass",
    "726752001": "Red snapper",
    "726753006": "Parsnip",
    "726754000": "Parrot fish",
    "726755004": "Leek",
    "726756003": "Krill oil",
    "726757007": "Gourd",
    "726758002": "Endive",
    "726759005": "Cuttlefish",
    "726760000": "Conger eel",
    "726761001": "Chicory",
    "726762008": "Catfish",
    "726763003": "Carp",
    "726764009": "Broad bean",
    "726765005": "Bloater",
    "72840006": "Valine",
    "733764007": "Monosodium aspartate monohydrate",
    "734466002": "Citrulline malate",
    "734646000": "Arginine aspartate",
    "734650007": "Lactitol monohydrate",
    "734656001": "Lysine aspartate",
    "734657005": "Lysine glutamate",
    "734658000": "Lysine hydrochloride",
    "734659008": "Lysine monohydrate",
    "734881000": "Tomato",
    "734977001": "Histidine monohydrochloride",
    "734978006": "Histidine monohydrochloride monohydrate",
    "735002001": "Terrestrial mollusk",
    "735004000": "Sweet potato",
    "735006003": "Squid",
    "735007007": "Skate",
    "735008002": "Sandwich",
    "735009005": "Salmon",
    "735010000": "Saffron",
    "735029006": "Shellfish",
    "735030001": "Garlic",
    "735033004": "Haddock",
    "735034005": "Trout",
    "735035006": "Herring",
    "735040003": "Horseradish",
    "735042006": "Lettuce",
    "735043001": "Mackerel",
    "735044007": "Mullet",
    "735045008": "Mushroom",
    "735046009": "Nutmeg",
    "735047000": "Onion",
    "735048005": "Parsley",
    "735049002": "Peach",
    "735050002": "Pear",
    "735051003": "Plum",
    "735052005": "Pomfret",
    "735053000": "Potato",
    "735062003": "Tidiacic arginine",
    "735066000": "Dapabutan",
    "735106000": "Basil",
    "735108004": "Cabbage",
    "735122004": "Brussels sprouts",
    "735123009": "Broccoli",
    "735124003": "Barley",
    "735136009": "Acetylleucine",
    "735211005": "Coconut",
    "735212003": "Papaya",
    "735213008": "Cucumber",
    "735214002": "Apricot",
    "735215001": "Apple",
    "735245003": "Cod",
    "735246002": "Eel",
    "735247006": "Corn oil",
    "735248001": "Cherry",
    "735249009": "Avocado",
    "735252001": "Protein and protein derivative",
    "735336002": "Cauliflower",
    "735337006": "Anchovy",
    "735340006": "Lemon",
    "735341005": "Fish oil",
    "735959004": "Marine mollusk",
    "735971005": "Fish",
    "735972003": "Crayfish",
    "735974002": "European eel",
    "735977009": "Marine crustacean",
    "735979007": "Octopus",
    "736027000": "Scallop",
    "736030007": "Clam",
    "736031006": "Oyster",
    "736159005": "Crab",
    "736162008": "Lobster",
    "73916008": "Oxitriptan",
    "74242007": "Food starch",
    "7434003": "Erythrosin B stain",
    "74727008": "Hydroxyproline",
    "75476008": "Bovine growth hormone",
    "75665004": "Monosodium glutamate",
    "75799006": "Lysine",
    "75871008": "Argininosuccinic acid",
    "762952008": "Peanut",
    "762953003": "Mustard seasoning",
    "763052004": "Ornithine hydrochloride",
    "763053009": "Ornithine oxoglurate",
    "763201006": "Diornithine oxoglurate dihydrate",
    "763371007": "Spaglumate sodium",
    "765097005": "Tinned shellfish",
    "765098000": "Abalone",
    "765099008": "Pilchard",
    "765355009": "Soybean unsaponifiables",
    "765849005": "Fluciclovine",
    "766042009": "Fluorethyltyrosine",
    "7661006": "Fish bone",
    "767406000": "Sulfite and sulfite derivative",
    "769350006": "Ginger ale",
    "769352003": "Non-carbonated drink",
    "770326002": "Mollusk",
    "771518004": "Stone fruit of genus Prunus",
    "771581000": "Chokecherry",
    "771582007": "Sloe",
    "77404006": "Homoserine",
    "77722008": "Poultry bone",
    "7791007": "Soy protein",
    "781246008": "Macimorelin",
    "781247004": "Macimorelin acetate",
    "781253004": "Netarsudil",
    "784335008": "Succinylated gelatin",
    "784398008": "Porcine heparin sodium",
    "784400007": "Bovine hyaluronidase",
    "789256005": "High-intensity sweetener",
    "789602006": "Carob seed flour",
    "792875007": "Fortified food",
    "792904006": "Enriched food",
    "792905007": "Beverage containing caffeine",
    "792910006": "Quick service food",
    "79907004": "Aminobenzoic acid derivative",
    "80259003": "Food flavoring agent",
    "80393001": "Diiodotyrosine",
    "80743002": "Mustard black",
    "8153000": "Pipecolic acid",
    "816174002": "Beverage containing high intensity sweetener",
    "818989004": "Sugar sweetened beverage",
    "819009007": "Self prepared food",
    "819010002": "Processed food",
    "819011003": "Prepared food",
    "819013000": "Special dietary food",
    "819018009": "Nutritionally complete liquid supplement",
    "819974004": "Donor breast milk",
    "823054000": "Liquid meal replacement",
    "82450006": "Cottonseed oil",
    "82566005": "Animal feed",
    "83235009": "Bovine growth hormone recombinant",
    "83595008": "Goat's milk",
    "83797003": "Leucine",
    "84035007": "Cystathionine",
    "84791008": "Sodium metabisulfite",
    "8514004": "Ornithine",
    "85214009": "Glutamic acid",
    "85668006": "Starch powder",
    "86233005": "Sulfur dioxide",
    "87136001": "Asparagine",
    "88546006": "Sarcosine",
    "89707004": "Sesame oil",
    "89811004": "Gluten",
    "90136002": "Pink wine",
    "90677004": "Mustard white",
    "91166002": "Monoiodotyrosine",
    "91606004": "Cochineal stain",
    "95984008": "Alpha-aminoadipic acid",
    "96147003": "Ethopabate",
    "96172003": "Meclofenamic acid",
    "96364008": "Sometribove",
    "443701000124100": "TODO",
    "444001000124100": "TODO",
    "442681000124105": "TODO",
    "442361000124108": "TODO",
    "442891000124107": "TODO",
    "442341000124109": "TODO",
    "442751000124107": "TODO",
    "9424004": "TODO",
    "443981000124106": "TODO",
    "442861000124104": "TODO",
    "412070003": "TODO",
    "443691000124100": "TODO",
    "444021000124105": "TODO",
    "328685004": "TODO",
    "901000161107": "TODO",
    "442811000124102": "TODO",
    "444161000124100": "TODO",
    "442581000124106": "TODO"
};
export default snomedCT;